// Types that produced scores before the explicit competition flag existed.
const LEGACY_COMPETITION_TYPES = ['betting', 'quiz', 'shuffleboard', 'game'];

export function defaultIsCompetition(type) {
  return LEGACY_COMPETITION_TYPES.includes(type);
}

// Competition activities hold scores. Team-based activities are always competitions;
// older activities without an explicit choice fall back to their type.
export function isCompetitionActivity(activity) {
  if (!activity) return false;
  if (activity.isTeamBased) return true;
  if (typeof activity.isCompetition === 'boolean') return activity.isCompetition;
  return defaultIsCompetition(activity.type);
}
